import { render, staticRenderFns } from "./BillReceivebleStatusBadge.vue?vue&type=template&id=1f6fb012"
import script from "./BillReceivebleStatusBadge.vue?vue&type=script&lang=js"
export * from "./BillReceivebleStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports